/* eslint-disable @typescript-eslint/no-require-imports */
import CustomPlatform from "$src/core/utils/platform/platform";

export type { EPGChannelGridHandle } from "./types";

export default CustomPlatform.select({
  tv: require("./EPGChannelGrid.tv").default,
  default: require("./EPGChannelGrid").default,
});
